import { render, staticRenderFns } from "./brandTab.vue?vue&type=template&id=352467b3&scoped=true&"
import script from "./brandTab.vue?vue&type=script&lang=js&"
export * from "./brandTab.vue?vue&type=script&lang=js&"
import style0 from "./brandTab.vue?vue&type=style&index=0&id=352467b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352467b3",
  null
  
)

export default component.exports